import React, { useMemo } from "react";
import { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Button } from "../../../components/button.component";
import { Card } from "../../../components/card.component";
import { AppRouteUi } from "../../../config/appRoute";
import { ApiPatientTask } from "../../../core/apis";
import { TaskListForm } from "../../../features/taskList/addTask.component";
import { TableCardPlaceholder } from "../../../components/placeholders.component";
import { ActionsTaskTable } from "../../../core/redux/slices/sliceTaskTable";
import { useAppDispatch } from "../../../core/redux/ReduxStore";
import { DoesObjectHasAnyInvalidValue } from "../../../utils/formUtils";

export function PageTaskListUpdate(): JSX.Element {
  const { taskId } = useParams<{ taskId: string }>();
  const [formData, setFormData] = useState({
    name: "",
    displayName: "",
    isDefaultForDHHS: false,
    isDafult: false,
    procedureCode: "",
    precedence: 0,
  });
  const [isLoading, setIsLoading] = useState(false);
  const routeHistory = useHistory();
  const { data, isValidating } = ApiPatientTask.ById.Hook(taskId);
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    setFormData({
      name: data?.name || "",
      displayName: data?.displayName || "",
      isDefaultForDHHS: !!data?.isDefaultForDHHS,
      isDafult: !!data?.isDefault,
      procedureCode: data?.procedureCode || "",
      precedence: data?.precedence || 0,
    });
  }, [data]);

  const [formError, setFormError] = useState({});

  const isDisabled = useMemo(() => {
    const { isDefaultForDHHS, procedureCode, isDafult, ...rest } = formData;
    const isEmpty = Object.values(rest).some(DoesObjectHasAnyInvalidValue);
    const errorCount = Object.keys(formError).length;
    return isEmpty || !!errorCount;
  }, [formData, formError]);

  const onSave = React.useCallback(async () => {
    setIsLoading(true);
    if (!isDisabled) {
      const result = await ApiPatientTask.Update({
        sKey: taskId,
        ...formData,
      });
      if (result) {
        dispatch(ActionsTaskTable.goToPage(1));
        routeHistory.push(AppRouteUi.ManageTaskList.Root());
      }
    }
    setIsLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [routeHistory, formData, taskId, isDisabled]);

  return (
    <Card
      header={
        <div className="row align-items-center justify-content-between">
          <div className="col content-box-title">
            <div className="d-flex align-items-center">
              <div
                onClick={() => {
                  routeHistory.length > 1
                    ? routeHistory.goBack()
                    : routeHistory.push(AppRouteUi.Root);
                }}
                className="pe-2 border-2 border-end click text-green-200"
              >
                <i className="fas fa-arrow-left text-green-200" />
              </div>
              <p className="text-capitalize mb-0 ps-2  text-green-200">
                Update Task
              </p>
            </div>
            <div className="collapse-icon"></div>
          </div>
        </div>
      }
    >
      <div className="row">
        <div className="col-md-10 col-12 border-end">
          {isValidating ? (
            <TableCardPlaceholder rows={2} />
          ) : (
            <TaskListForm
              value={formData}
              readOnly={isLoading}
              onChange={(formValue) =>
                setFormData({ ...formData, ...formValue })
              }
              onCheck={setFormError}
            />
          )}
        </div>
        <div className="col-md-2 col-12 mt-3">
          <Button
            className="m-1 w-100 btn-green"
            name="Save"
            loading={isLoading}
            disabled={isDisabled}
            onClick={onSave}
          />
          <Button
            onClick={() => {
              routeHistory.length > 1
                ? routeHistory.goBack()
                : routeHistory.push(AppRouteUi.Root);
            }}
            type="button"
            className="m-1 w-100 btn-green-subtle"
            name="Return without saving"
            disabled={isLoading}
          />
        </div>
      </div>
    </Card>
  );
}
